import { UploadDetailsPopUpProps } from "./types";
import { Box, ButtonBase, CircularProgress, Typography } from "@mui/material";
import { styles } from "./styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export const FileUploadStatusCard: React.FC<UploadDetailsPopUpProps> = ({
  uploadingFilesDetailsList,
  setIsUploading,
  uploadingCardsStatusList,
  setUploadingCardsStatusList,
}) => {
  const [isDrawerMinimize, setIsDrawerMinimize] = useState<boolean>(false);

  const drawerStyle = {
    transition: "height 1s ease",
    height: isDrawerMinimize ? "50px" : "auto",
  };

  const handleCloseUploadingCard = (index: number) => {
    setUploadingCardsStatusList(
      uploadingCardsStatusList.map((file, i) =>
        i === index ? { ...file, isCardClosed: true } : file
      )
    );
  };

  return (
    <>
      <Box
        sx={{ ...styles.uploadingFilesDetailsListContainer, ...drawerStyle }}
      >
        <Box sx={styles.topBar}>
          <Typography
            variant="h6"
            sx={{ padding: "8px", margin: 0, fontSize: "17px" }}
          >
            Uploading {uploadingFilesDetailsList.length} items
          </Typography>
          <Box>
            <ButtonBase
              onClick={() => setIsDrawerMinimize(!isDrawerMinimize)}
              sx={{ padding: "8px" }}
            >
              {isDrawerMinimize ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </ButtonBase>
            <ButtonBase
              onClick={() => setIsUploading(false)}
              sx={{ padding: "8px" }}
            >
              <CloseIcon onClick={() => {}} />
            </ButtonBase>
          </Box>
        </Box>
        {!isDrawerMinimize && (
          <Box
            sx={{ width: "100%", border: "1px solid gray", marginTop: "3px" }}
          ></Box>
        )}
        <Box sx={styles.scrollBox}>
          {uploadingFilesDetailsList.map((file: any, index: number) => {
            return (
              <Box
                sx={
                  file.isCardOpen &&
                  !uploadingCardsStatusList[index].isCardClosed
                    ? {}
                    : { display: "none" }
                }
                key={index}
              >
                <Box sx={styles.popUpContainer}>
                  <Box sx={styles.progressWrapper}>
                    <Box sx={styles.infoContainer}>
                      <Typography
                        sx={{ fontSize: "14px", paddingTop: "5px" }}
                        variant="h6"
                      >
                        {file.name}
                      </Typography>
                      <Typography variant="h6" sx={styles.progressText}>
                        {file.uploadProgress}%
                      </Typography>
                    </Box>
                    <Box sx={styles.progressContainer}>
                      {file.uploadProgress === 100 ? (
                        <CheckCircleIcon />
                      ) : (
                        <CircularProgress
                          sx={{ padding: "6px", marginTop: "5px" }}
                        />
                      )}
                    </Box>
                    <Box sx={styles.progressContainer}>
                      <ButtonBase>
                        <CloseIcon
                          onClick={() => handleCloseUploadingCard(index)}
                        />
                      </ButtonBase>
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};
